/* eslint-disable standard/computed-property-even-spacing */
import React, { Component, Fragment } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isEqual from 'lodash.isequal';
import { Button } from '@xingternal/button';
import styles from './SearchSuggestions.css';
import sectionComponents from './sections';
const RECENT_SEARCHES_SECTION = 'RECENT_SEARCHES';
const EMPTY_STATE_SECTIONS = [
    'NAVIGATION_SUGGESTIONS',
    RECENT_SEARCHES_SECTION,
    'RECENT_ITERACTIONS',
];
const filterSections = (sections, query) => sections
    .filter(({ sectionType, items }) => Object.keys(sectionComponents).includes(sectionType) &&
    (query.length && items.length > 0
        ? !EMPTY_STATE_SECTIONS.includes(sectionType)
        : EMPTY_STATE_SECTIONS.includes(sectionType)))
    .map((section) => {
    if (section.sectionType === RECENT_SEARCHES_SECTION) {
        return {
            ...section,
            items: section.items.slice(0, 3),
        };
    }
    return section;
});
const ItemType = PropTypes.shape({
    trackingToken: PropTypes.string.isRequired,
    payload: PropTypes.shape({
        title: PropTypes.string,
        subtitle: PropTypes.string,
        url: PropTypes.string,
        thumbnail: PropTypes.string,
    }),
});
const SectionType = PropTypes.shape({
    sectionType: PropTypes.string.isRequired,
    title: PropTypes.string,
    link: PropTypes.string,
    items: PropTypes.arrayOf(ItemType).isRequired,
});
export default class SearchSuggestions extends Component {
    constructor() {
        super(...arguments);
        this.formDSTrackingData = (sections) => {
            const { userId } = this.props;
            let index = 0;
            return sections
                .map((section) => {
                return section.items.map(({ trackingToken }) => {
                    return {
                        consumer: 'rest.api.search.incremental_search',
                        service: 'ds.incremental_search.universal',
                        trackingToken,
                        position: index++,
                        interactionType: 'shown',
                        userId,
                    };
                });
            })
                .flat();
        };
    }
    componentDidMount() {
        const { sections, query, executeSearchTracking } = this.props;
        sections.length &&
            executeSearchTracking &&
            executeSearchTracking(this.formDSTrackingData(filterSections(sections, query)));
    }
    componentDidUpdate(prevProps) {
        const { sections, query, executeSearchTracking } = this.props;
        if (executeSearchTracking && !isEqual(prevProps.sections, sections)) {
            executeSearchTracking(this.formDSTrackingData(filterSections(sections, query)));
        }
    }
    render() {
        const { getItemProps, highlightedIndex, searchLink, sections, userId, type, query = '', } = this.props;
        return sections ? (React.createElement(Fragment, null,
            React.createElement("div", { "data-qa": "search-suggestions", className: cx(styles.container, query.length && styles.withMore) }, [...filterSections(sections, query)].map(({ sectionType, ...section }, _, ctx) => {
                const { i = 0 } = ctx;
                const Comp = sectionComponents[sectionType];
                if (!Comp || !section.items.length) {
                    return null;
                }
                ctx.i = i + section.items.length;
                return (React.createElement(Comp, { key: sectionType, baseI: i, highlightedIndex: highlightedIndex, section: section, getItemProps: getItemProps, userId: userId, searchType: type }));
            })),
            Boolean(query.length) && (React.createElement("section", { className: styles.sectionMore, "data-qa": "search-all-results" },
                React.createElement(Button, { size: "medium", variant: "secondary", href: searchLink({
                        query,
                        trackingKey: 'all_results_fallback',
                    }) },
                    React.createElement(FormattedMessage, { id: 'VERTICAL_NAVIGATION_HEADER_SEARCH_ALL_RESULTS' })))))) : null;
    }
}
SearchSuggestions.propTypes = {
    sections: PropTypes.arrayOf(SectionType),
    getItemProps: PropTypes.func.isRequired,
    userId: PropTypes.string.isRequired,
    searchLink: PropTypes.func.isRequired,
    highlightedIndex: PropTypes.number,
    executeSearchTracking: PropTypes.func,
    query: PropTypes.string,
    type: PropTypes.string,
};
SearchSuggestions.defaultProps = {
    sections: [],
};
//# sourceMappingURL=SearchSuggestions.js.map